export const CLONE_TABLE_ROW_HEIGHT = 80;
export const CLONE_TABLE_PANEL_HEADER_HEIGHT = 40;
export const CLONE_TABLE_GRID_HEADER_HEIGHT = 40;
